import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const UseUpdateGiftcardInBasket = async (
    token,
    giftCertificateData,
    basket,
    giftCertificateItemId
) => {
    const {amount, recipientEmail, shipmentId, recipientName, senderName, c_senderEmail} =
        giftCertificateData

    const senderEmail = c_senderEmail

    const config = getConfig()
    const body = JSON.stringify({
        amount,
        recipientEmail,
        shipmentId,
        recipientName,
        senderName,
        c_senderEmail: senderEmail
    })

    if (!token) return null

    try {
        const apiUrl = `${getAppOrigin()}/mobify/proxy/api/checkout/shopper-baskets/v2/organizations/${
            config?.app?.commerceAPI?.parameters?.organizationId
        }/baskets/${basket.basketId}/gift-certificate-items/${giftCertificateItemId}?siteId=${
            config?.app?.defaultSite
        }`

        const response = await fetch(apiUrl, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const json = await response.json()

        if (json?.giftCertificateItems?.length > 0) {
            json.giftCertificateItems = json.giftCertificateItems.map((item) => ({
                ...item,
                c_senderEmail: senderEmail
            }))
        }

        return json
    } catch (error) {
        logger.error('Error while update gift certificate to basket:', error)
        throw error
    }
}
